import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES } from './constants';

const Mark = ({ children, size = SIZES.inherit, appearance = APPEARANCES.inherit }) => (
  <Text type={TYPES.mark} size={size} appearance={appearance}>
    {children}
  </Text>
);

Mark.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
};

export default Mark;
